<template>
    <div class="mian">
        <!-- 侧边栏 -->
        <div class="leftbox">
            <!-- 内容区域 -->
            <img class="imgbox" src="@/assets/Mask group@2x.png" />
            <!-- 列表区域 -->
            <div class="listbox">
                <div class="iconbox" @click="gohome">
                    <img class="iconbox" src="@/assets/icon@2x.png" alt="">
                </div>
                <div class="search">
                    <!-- <input class="inputbox" type="text" placeholder=""> -->
                    <!-- <img class="searchiconbox" src="@/assets/Frame@2x.png" alt=""> -->
                </div>
                <div class="menubox">
                    <el-menu :default-active="menu" unique-opened active-text-color="#FF8C00" text-color="#888888"
                        @select="selectfun">
                        <el-sub-menu index="1">
                            <template #title>
                                <el-icon>
                                    <img style="width: 20px;height: 20px;" src="../../assets/menuicon/dinghuo@2x.png"
                                        alt="" srcset="">
                                </el-icon>
                                <span>订单管理</span>
                            </template>
                            <el-menu-item index="/Orderlist">订货订单</el-menu-item>
                            <el-menu-item index="/ReturnOrders">退货订单</el-menu-item>
                        </el-sub-menu>
                        <el-sub-menu index="2">
                            <template #title>
                                <el-icon>
                                    <img style="width: 20px;height: 20px;" src="../../assets/menuicon/shangp@2x.png"
                                        alt="" srcset="">
                                </el-icon>
                                <span>商品管理</span>
                            </template>
                            <el-menu-item index="/Listproducts">商品列表</el-menu-item>
                            <el-menu-item index="/productreturn-list">商品退货</el-menu-item>
                            <el-menu-item index="/inventory-list">商品入库</el-menu-item>
                            <el-menu-item index="/Listcategories">类目列表</el-menu-item>
                        </el-sub-menu>
                        <el-sub-menu index="3">
                            <template #title>
                                <el-icon>
                                    <img style="width: 20px;height: 20px;" src="../../assets/menuicon/yajin@2x.png"
                                        alt="" srcset="">
                                </el-icon>
                                <span>财务管理</span>
                            </template>

                            <el-menu-item index="/financial_management">结算单列表</el-menu-item>

                        </el-sub-menu>
                        <el-sub-menu index="4">
                            <template #title>
                                <el-icon>
                                    <img style="width: 20px;height: 20px;" src="../../assets/menuicon/tuihuo@2x.png"
                                        alt="" srcset="">
                                </el-icon>
                                <span>数据统计</span>
                            </template>
                            <el-menu-item index="/Orderstatistics">商品统计</el-menu-item>

                        </el-sub-menu>
                        <el-sub-menu index="5">
                            <template #title>
                                <el-icon>
                                    <img style="width: 20px;height: 20px;" src="../../assets/menuicon/shezhi@2x.png"
                                        alt="" srcset="">
                                </el-icon>
                                <span>系统设置</span>
                            </template>
                            <el-menu-item index="/Systemsettings">收货地址</el-menu-item>
                            <el-menu-item index="/AccountForm">账户信息</el-menu-item>
                        </el-sub-menu>
                    </el-menu>
                </div>
            </div>
        </div>
        <div class="rightbox">
            <header>
                <div class="Page_Routing">
                </div>
                <div class="plaintext">
                    <img class="iconbox" src="../../assets/menuicon/tongzhi@2x.png" alt="" @click="navigate_one()">
                    <div class="conentbox">
                        <img class="userimg" src="../../assets/menuicon/touxiang@2x.png" alt="">
                        <el-popover placement="bottom" trigger="click" show-arrow='false'
                            popper-class="monitor-yt-popoverone_100086" :offset="10">
                            <template #reference>
                                <div class="Dropdownbox" @click="Dropdownbox = !Dropdownbox">
                                    <div class="ellipsis">
                                        {{ userinfo.nickname }}
                                    </div>
                                    <div class="iconfont icon-sanjiaoxing">
                                    </div>
                                </div>
                            </template>
                            <div class="listboxuser">
                                <div class="item" @click="navigate_verify()">企业验证</div>
                                <div class="item" @click="navigate_chage('/changepass')">修改密码</div>
                                <div class="item" @click="navigate('/')">退出账号</div>

                            </div>
                        </el-popover>


                    </div>
                </div>
            </header>
            <!-- 路由出口 -->
            <div class="main">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watchEffect, watch } from 'vue';
import { useRouter, useRoute } from "vue-router";

const userinfo: any = ref({})
if (localStorage.getItem('usetoken')) {
    let data: any = localStorage.getItem('userinfo')
    userinfo.value = JSON.parse(data)
}

/**
 * 控制 管理员下拉列表模块的显示隐藏
 */
const Dropdownbox = ref(false)
const router = useRouter()
const route = useRoute()
/**
 * 跳转消息列表
 */
const navigate = (url: string) => {
    localStorage.clear()
    router.push({ path: '/Login' })
}

const navigate_chage = (url: string) => {
    router.push({ path: url })
}
const navigate_verify = () => {
    router.push({ path: '/verify' })
}
const navigate_one = () => {
    router.push({ path: '/notice' })
}
/** 
 * 展开回调
*/
const selectfun = (e: any) => {
    console.log(e, '展开回调');
    if (e.includes('/')) {
        router.push({ path: e })
    }
}
/**
 * 默认展开
 */
const menu = ref('')
/**
 * 跳转到首页
 */
const gohome = () => {
    router.push({ path: '/onhome' })
}
watch(route, (newdata, olddata) => {
    console.log('路由发生变化', newdata, olddata);
    menu.value = newdata.fullPath

}, { immediate: true })

</script>

<style lang="less" scoped>
.listboxuser {
    // position: absolute;
    width: 160px;
    height: auto;
    background: rgba(255, 255, 255, 1);
    // background: wheat;
    border-radius: 10px 10px 10px 10px;
    // border: 1px solid;
    border-image: linear-gradient(136deg, rgba(255, 255, 255, 1), rgba(243, 243, 243, 1)) 1 1;
    bottom: -160px;
    transition-duration: 0.2s;
    overflow: hidden;

    .item {
        font-weight: 400;
        font-size: 14px;
        color: #FF8C00;
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }

    .item:hover {
        background: #FF8C00;
        color: white;
    }
}

.mian {
    width: 100%;
    height: 100%;

    background: #F3F3F3;
    display: flex;

    .Dropdownbox {
        width: 160px;
        height: auto;
        // background: wheat;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 20px;
        position: relative;

        .ellipsis {
            width: 80px;
            text-align: center;
            /* 必须设置固定宽度或max-width */
            white-space: nowrap;
            /* 禁止换行 */
            overflow: hidden;
            /* 隐藏溢出内容 */
            text-overflow: ellipsis;
            /* 显示省略符号 */

        }


    }


    .leftbox {
        width: 200px;
        height: 100%;
        background: linear-gradient(180deg, #FFBF00 0%, #FF6F00 100%);
        position: relative;
        flex-shrink: 0;

        .imgbox {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 1;
            flex-shrink: 0;
        }

        .listbox {
            width: 100%;
            height: 100%;
            position: absolute;
            z-index: 2;
            box-sizing: border-box;
            padding: 43px 0px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .iconbox {
                width: 134px;
                height: 53px;
                margin-bottom: 20px;

            }

            .search {
                width: 180px;
                height: 28px;
                // background: #FFFFFF;
                border-radius: 8px;
                display: flex;
                justify-content: space-between;
                box-sizing: border-box;
                padding: 14px 10px;
                margin-bottom: 20px;

                .inputbox {
                    width: 130px;
                    height: 100%;
                    border: none !important;
                }

                .searchiconbox {
                    width: 22px;
                    height: 22px;
                }



            }

            .menubox {
                width: 100%;
                flex: 1;
                box-sizing: border-box;
                padding: 0 20px;

                // background: wheat;
                ::v-deep(.el-menu) {
                    background: none;
                    border: none;

                    .el-sub-menu {
                        background: rgba(45, 45, 45, 0.1);
                        border-radius: 10px;
                        margin-bottom: 20px !important;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 600;
                        font-size: 18px;
                        // --el-menu-item-hover-fill:#FF8C00 !important;
                        --el-menu-hover-bg-color: none;
                        --el-menu-item-height: 42px;
                        overflow: hidden;

                        .el-icon svg {
                            width: 16px;
                            height: 16px;
                            color: white;
                        }

                        .el-menu--inline {
                            background: white;
                            font-family: PingFang SC, PingFang SC;
                            font-weight: 600;
                            font-size: 18px;
                            color: red;
                        }

                        .el-sub-menu__title {
                            --el-menu-base-level-padding: 10px // padding: none !important;s
                                // .el-icon el-sub-menu__icon-arrow{

                                // }
                                // --el-menu-level-padding: 10px #888888;

                        }

                        .el-menu-item {
                            padding-left: 10px;

                            font-weight: 400;
                            font-size: 16px;
                            // color: #888888;
                        }

                        span {
                            color: #FFFFFF !important;
                        }
                    }


                }
            }

            // background:red;
        }
    }

    .rightbox {
        flex: 1;
        height: 100%;
        box-sizing: border-box;
        padding-left: 20px;
        display: flex;
        flex-direction: column;

        header {
            width: 100%;
            height: 80px;
            background: #FF8C00;
            border-radius: 0px 0px 0px 20px;
            display: flex;
            justify-content: space-between;

            .Page_Routing {
                width: 400px;
                height: 100%;
                // background: wheat;
            }

            .plaintext {
                min-width: 100px;
                height: 100%;
                box-sizing: border-box;
                padding: 0 20px;
                display: flex;
                align-items: center;
                // background: wheat;

                .iconbox {
                    width: 32px;
                    height: 32px;
                    margin-right: 30px;
                }

                .conentbox {
                    flex: 1;
                    height: 100%;
                    // background: wheat;
                    display: flex;
                    align-items: center;

                    .userimg {
                        width: 42px;
                        height: 42px;
                    }


                }

            }
        }

        .main {
            flex: 1;
            height: 100%;
            box-sizing: border-box;
            padding-right: 20px;
            padding-bottom: 20px;
            overflow: hidden;
            // background:white;
        }
    }

}
</style>
<style>
.el-popover.monitor-yt-popoverone_100086 {
    width: 160px !important;
    height: auto !important;
    background: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    overflow: hidden;
    padding: 0px !important;


    /* inset: <top> <right> <bottom> <left>; */

}

.monitor-yt-popoverone_100086 .el-popper__arrow:before {
    display: none;
}

.monitor-yt-popoverone_100086 .el-popover__title {
    color: white;
}


.monitor-yt-popoverone_100086 .popper__arrow::after {
    border-top-color: #090d29 !important;
}
</style>
